import(/* webpackMode: "eager" */ "/home/watchero/watchero-servers/packages/watchero.io/app/(marketing)/tools/full-page-website-screenshot/og.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["WebsiteScreenshotGenerator"] */ "/home/watchero/watchero-servers/packages/watchero.io/components/tools/website-screenshot/website-screenshot-generator.tsx");
